// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"d2d3c2de","793":"b621fef8"}[chunkId] + ".chunk.css";
};